import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ReactComponent as LogoIcon } from "@/assets/logo/union_ver1.svg?react";
import {
  PageContainer,
  FormContainer,
  LoginInputTextStyle,
  LoginButtonStyle,
  HelperLinks,
  BackgroundGlow,
  SignupSection,
  DividerLine,
} from "./styles";
import { useModal } from "store/modalStore";
import { useAuthStore } from "../../../store/authStore";
import { Logo } from "styles/styles";
import { KoHeadline } from "styles/sharedStyles";

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuthStore();
  const { openInfo } = useModal();

  useEffect(() => {
    const state = location.state as { showAlert?: boolean; message?: string } | null;
    if (state?.showAlert) {
      openInfo({
        title: "회원가입 완료",
        message: state.message || "회원가입이 성공적으로 완료되었습니다."
      });
      navigate(location.pathname, { replace: true });
    }
  }, [location, openInfo, navigate]);

  const isValidEmail = (email: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const isFormValid = email && password && isValidEmail(email);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      await login({ email, password });
      navigate("/workspace");
    } catch {
      openInfo({ title: "로그인 실패", message: "이메일 또는 비밀번호가 올바르지 않습니다." });
    }
  };

  return (
    <PageContainer>
      <BackgroundGlow />

      <FormContainer onSubmit={handleSubmit}>
      <Logo onClick={() => navigate("/")}>
        <LogoIcon style={{ width: "32px", height: "30px" }} />
      </Logo>

      <KoHeadline style={{ fontWeight: 600, marginBottom: "24px" }}>로그인</KoHeadline>
        <LoginInputTextStyle
          type="text"
          placeholder="이메일"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <LoginInputTextStyle
          type="password"
          placeholder="비밀번호"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <LoginButtonStyle type="submit" disabled={!isFormValid}>
          로그인
        </LoginButtonStyle>

        <HelperLinks>
          <Link to="/forgot-password">비밀번호 찾기</Link>
        </HelperLinks>
        <DividerLine />
        <SignupSection>
          <p>아직 계정이 없으신가요?</p>
          <button type="button" onClick={() => navigate("/signup")}>
            회원가입하고 무료로 시작하기 →
          </button>
        </SignupSection>
      </FormContainer>
    </PageContainer>
  );
};

export default LoginPage;
